var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, memo, useCallback, useEffect, useState } from 'react';
import classnames from 'classnames';
import { Card, CardActions, CardContent, Collapse, Typography } from '@material-ui/core';
import useStyles from './style';
import ExpandIcon from './ExpandIcon';
function ExpandableCard(_a, ref) {
    var children = _a.children, className = _a.className, _b = _a.defaultExpanded, defaultExpanded = _b === void 0 ? true : _b, title = _a.title, _c = _a.showIcon, showIcon = _c === void 0 ? true : _c, onExpandChange = _a.onExpandChange, _d = _a.unmountOnExit, unmountOnExit = _d === void 0 ? true : _d, headerContent = _a.headerContent, rest = __rest(_a, ["children", "className", "defaultExpanded", "title", "showIcon", "onExpandChange", "unmountOnExit", "headerContent"]);
    var classes = useStyles();
    var _e = useState(defaultExpanded), expanded = _e[0], setExpanded = _e[1];
    var handleExpandToggle = useCallback(function () {
        setExpanded(!expanded);
        if (onExpandChange) {
            onExpandChange(!expanded);
        }
    }, [expanded, onExpandChange, setExpanded]);
    useEffect(function () {
        setExpanded(defaultExpanded);
    }, [defaultExpanded]);
    return (_jsxs(Card, __assign({ className: classnames(className, classes.card), "data-testid": "expandable-card", ref: ref }, rest, { children: [_jsxs(CardActions, __assign({ disableSpacing: true, className: classes.actions, onClick: handleExpandToggle, "data-testid": "action-card" }, { children: [_jsx(Typography, __assign({ className: classes.title, component: "div", "data-testid": "card-title" }, { children: title }), void 0),
                    showIcon && _jsx(ExpandIcon, { expanded: expanded }, void 0)] }), void 0),
            headerContent && _jsx(CardContent, { children: headerContent }, void 0),
            _jsx(Collapse, __assign({ className: classes.collapse, in: expanded, timeout: "auto", unmountOnExit: unmountOnExit, "data-testid": "card-collapse" }, { children: _jsx(CardContent, __assign({ className: classes.content, "data-testid": "card-content" }, { children: children }), void 0) }), void 0)] }), void 0));
}
export default memo(forwardRef(ExpandableCard));
